<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<span class="header-app-title">COMPASS DB</span>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle" v-if="this.$store.getters.isInternalUser">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" @click="onSettingsToggle" >
			<i class="pi pi-ellipsis-v"></i>
		</button>

		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li class="hidden">
				<button class="p-link layout-topbar-button">
					<i class="pi pi-calendar"></i>
					<span>Events</span>
				</button>
			</li>
			<li>
				<Menu ref="settings" :model="settingsMenuItems" :popup="true" />
				<button class="p-link layout-topbar-button" @click="onSettingsToggle">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>
			</li>
			<li>
				<Menu ref="profile" :model="profileMenuItems" :popup="true" style="width:auto;" class="mr-2" />
				<button class="p-link layout-topbar-button" @click="onProfileToggle">
					<i class="pi pi-user"></i>
					<span>Profile</span>
				</button>
			</li>
		</ul>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';

	@Options({
		name: 'AppTopBar',
		components: {
		},
		props: {
			email: String,
		}
	})

	export default class AppTopBar extends Vue {
		username!: string;

		profileMenuItems = [
			{
				label: (this as any).email,
				items: [
					{
						label: 'Change Password',
						to: { name: 'ChangePassword' }
					},
					{
						label: 'Logout',
						command: () => { this.$emit('logout') }
					},
				]
			},
		]

		settingsMenuItems = [
			{
				label: 'Settings',
				items: [
					{
						label: 'Refresh App',
						command: () => { this.$emit('refreshApp') }
					},
				]
			},
		]

		onMenuToggle(event: Event) {
			this.$emit('menu-toggle', event);
		}

		onTopbarMenuToggle(event: Event) {
			this.$emit('topbar-menu-toggle', event);
		}

		onProfileToggle(event: Event) {
			(this.$refs as any).profile.toggle(event);
		}

		onSettingsToggle(event: Event) {
			(this.$refs as any).settings.toggle(event);
		}
	}
</script>